import React, { useState } from 'react';
import { useMediaQuery } from '@mantine/hooks';
import { em } from '@mantine/core';
import { Header } from './header/header';
import { Sidebar } from './sidebar/sidebar';
import { MobileDrawer } from './mobile-drawer/mobile-drawer';
import './main-layout.css';

interface MainLayoutProps {
  children: React.ReactNode;
}

/**
 * Main application layout component.
 * It provides the overall structure of the application, including the header,
 * sidebar, and a mobile drawer for responsive navigation.
 *
 * It manages responsive states (mobile/compact) and the open/closed state
 * of the mobile navigation drawer.
 */
export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const isMobile = useMediaQuery(`(max-width: ${em(768)})`) ?? false;
  const isCompact = useMediaQuery(`(max-width: ${em(480)})`) ?? false;
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <div className={`cb-shell${isMobile ? ' cb-shell--mobile' : ''}`}>
      <Header onMenuOpen={() => setDrawerOpen(true)} isMobile={isMobile} isCompact={isCompact} />
      {!isMobile && <Sidebar />}
      <MobileDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
      <main className={`cb-main${isMobile ? ' cb-main--mobile' : ''}`}>{children}</main>
    </div>
  );
};
